// extracted by mini-css-extract-plugin
export default {"favoritesContainer":"FavoritesStyles_favoritesContainer__BO0mT","removeButton":"FavoritesStyles_removeButton__ZMydX"};